var map = {
	"./black/liandong2.png": "NVoS",
	"./blue/liandong2.png": "hGq/",
	"./white/liandong2.png": "crlw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b3v2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/liandong2\.png$
// module id = b3v2
// module chunks = 24